module.exports = __webpack_public_path__ + "img/underline.366c3f07.svg";